import { createSelector } from "reselect";
import { values } from "lodash";
//EXTRACT THE PART OF THE STATE
const getData = state => state.data.familyValue;

const getFamilyValue = createSelector(getData, familyValue =>
  values(familyValue)
);

export default getFamilyValue;



// WEBPACK FOOTER //
// ./src/_selectors/dataSelectors/getFamilyValue.js